// A location fix remains visible after the weather estimate popup is dismissed.
// A new explicit locate action updates this marker; no background tracking.
export function createUserPositionMarker(map, maplibre, doc) {
    let marker = null;
    const remove = () => { marker?.remove(); marker = null; };
    map.on('remove', remove);
    return {
        update(coords, timestamp) {
            const lat = coords.latitude, lon = coords.longitude;
            if (!Number.isFinite(lat) || !Number.isFinite(lon) || Math.abs(lat) > 90 || Math.abs(lon) > 180) return false;
            if (!marker) {
                const dot = doc.createElement('div');
                dot.className = 'ws-user-position';
                dot.setAttribute('role', 'img');
                dot.style.cssText = 'width:20px;height:20px;border-radius:50%;background:#138ef3;border:3px solid white;box-shadow:0 0 0 7px #138ef333,0 2px 7px #001d5566';
                marker = new maplibre.Marker({element: dot, anchor: 'center'}).setLngLat([lon, lat]).addTo(map);
            }
            const time = new Date(Number.isFinite(timestamp) ? timestamp : Date.now()).toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'});
            const precision = Number.isFinite(coords.accuracy) && coords.accuracy >= 0 ? ` · ±${Math.ceil(coords.accuracy)} m` : '';
            const label = `La tua posizione · ${time}${precision}`;
            marker.getElement().setAttribute('aria-label', label);
            marker.getElement().title = label;
            marker.setLngLat([lon, lat]);
            return true;
        },
        remove,
    };
}
